import { Box, Paper, Typography } from "@mui/material";
import { BORDER, TEXT, TEXT_SOFT } from "../constants";

export default function ChartCard({ title, subtitle, extra, height = 280, children, sx }) {
  return (
    <Paper
      sx={{
        p: 2.5,
        borderRadius: "16px",
        border: `1px solid ${BORDER}`,
        boxShadow: "none",
        minWidth: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1, mb: 1.5 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontWeight: 700, color: TEXT, letterSpacing: "-0.02em", lineHeight: 1.25 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: TEXT_SOFT, mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {extra}
      </Box>
      <Box sx={{ flex: 1, width: "100%", minWidth: 0, height, minHeight: height }}>
        {children}
      </Box>
    </Paper>
  );
}
